/** The format of the module manifest JSON files. */
interface ModuleManifestJson {
  
  /** Gets the path to the module with the specified ID. */
  readonly [id: string]: string;
}

function replacePath(path: string): string {
  return path.replace("{{protocol}}", window.location.protocol).replace("{{hostname}}", window.location.hostname);
}

/**
 * Fetches the set of available modules.
 * @param set The set of modules to load. This can be "core" for core modules only or "app" for application modules.
 */
export async function fetchAvailableModules(set: "core" | "app"): Promise<ReadonlyArray<string> | null> {
  try {
    const response = await fetch(`/modules/module_manifest.${set}.json`);
    const modules = (await response.json()) as ModuleManifestJson;
    let paths = (Object.values(modules) || []).map(replacePath) as ReadonlyArray<string>;

    if (process.env.NODE_ENV === "development") {
      if (set === "app") {
        try {
          const response = await fetch("/modules/module_manifest.dev.json");
          const modules = (await response.json()) as ModuleManifestJson;
          const userPaths = (Object.values(modules) || []).map(replacePath) as ReadonlyArray<string>;
          paths = [...paths, ...userPaths];
        } catch {
          // no user modules, do nothing.
        }
      }
    }

    return paths;
  } catch (err) {
    console.warn("Unable to fetch list of available modules!");
    return null;
  }
}
